module.exports = __webpack_public_path__ + "static/media/BasierCircle-Medium.82ba2572.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Basier Circle/Web/BasierCircle-Medium.ttf
// module id = 515
// module chunks = 1